import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/lib/i18n/config';
import i18n from '@/lib/i18n/config';
import { getCurrentLanguage } from '@/lib/i18n/getCurrentLanguage';

export const isSupportedLanguage = (
  language: string | null | undefined
): language is SupportedLanguage =>
  !!language && (SUPPORTED_LANGUAGES as readonly string[]).includes(language);

export const syncDisplayLanguage = (language: SupportedLanguage) => {
  if (getCurrentLanguage() === language) return;

  void i18n.changeLanguage(language);
};
